
<router-outlet></router-outlet>
<ngx-guided-tour
    skipText="Passer"
    nextText="Suivant"
    doneText="Terminer"
    closeText="Fermer"
    backText="Précédent"
>

</ngx-guided-tour>
